import React,{useEffect} from 'react'
import { Result, Button } from 'antd';

const SuccessResult = ({ title, onPressExtraBtn }) => {

    useEffect(() => {
        const timeout = setTimeout(() => {
          // 👇️ redirects to an external URL
          window.location.replace('https://app.copanseguros.com.ar/sociosprueba');
        }, 3000);
    
        return () => clearTimeout(timeout);
      }, []);
      
    return (
        <Result
            style={{ marginTop: "100px" }}
            status="success"
            title={title}
            extra={[
                // <Button type="primary" key="console" onClick={onPressExtraBtn}>
                //     Ir al inicio
                // </Button>
                <h2>Redireccionando a pagina de socios...</h2>
            ]}
        />
    );
}

export default SuccessResult;